module.exports = __webpack_public_path__ + "img/icon-document.13a60fe8.png";